import { ConfirmCancelComponent } from './../confirm-cancel/confirm-cancel.component';
import { BreadCrumbService } from './../../../../lib/ng2-sapmp/src/ui-components/breadcrumb/breadcrumb.service';
import { BreadCrumbModel } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { Component, OnChanges, OnInit, ElementRef, ViewEncapsulation } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { GridOptionsModel, ColumnDefinitionsModel, PaginationsModel, FilterService } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { CancelParticipationService } from './../shared/providers/cancel-participation.service';
import { FanModel } from './../shared/models/cancel-participation.model';
import { Router, ActivatedRoute } from '@angular/router';
import { PageLoaderService } from './../../../../lib/ng2-sapmp/src/ui-components/page-loader/page-loader.service';
import { AccordionComponent } from 'lib/ng2-sapmp/src/ui-components/accordion/accordion.component';
import { CANCELFANDATA } from 'config';

@Component({
  selector: 'app-unclaim-devices',
  templateUrl: './unclaim-devices.component.html',
  styleUrls: ['./unclaim-devices.component.scss'],
  providers: [FilterService, CancelParticipationService, AdobeAnalyticsService],
  encapsulation: ViewEncapsulation.None
})

export class UnclaimDevicesComponent implements OnInit {
  formName: string;
  companyId: number;
  FANList: Array<FanModel>;
  SelectedFANList: Array<FanModel>;
  gridOptions: GridOptionsModel;
  columnSelection: string;
  callingBackUrl: string;
  selectedFan: any;
  showError: boolean;
  pageContent: any;
  fanid: any;
  unclaim: boolean;
  prodcode: string;
  mdmDetails: any;
  accountemmid: any;
  accountId: any;
  prodDets: any;
  fanInfoList: any;

  constructor(protected cancelParticipationService: CancelParticipationService, private router: Router,
    private breadCrumbService: BreadCrumbService, private utilityService: UtilityService, private pageLoaderService: PageLoaderService,
    private adobeAnalyticsService: AdobeAnalyticsService, private route: ActivatedRoute) {
    this.companyId = 2;  // Company ID four for Revised Setup (All fans)
    this.FANList = [];
    this.SelectedFANList = [];
    this.columnSelection = 'multicol';
    this.pageLoaderService.setPageLoaderStatus(false);
  }

  ngOnInit() {

    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.formName = 'Remove Devices';
    const totalFan = this.cancelParticipationService.getUnclaimDevicesData();
    this.unclaim = false;
    this.fanid = sessionStorage.getItem('fanID');
    if (totalFan) {
      this.FANList = totalFan.cancelledFanList;
      this.SelectedFANList = this.FANList.filter(item => item.selected === true);
      for (var i=0;i<this.SelectedFANList.length;i++) {
        this.SelectedFANList[i].selected = false;
      }
      //this.SelectedFANList = [];
      this.initGrid();
      this.getContent();
      this.pageLoaderService.setPageLoaderStatus(true);
    } else {
      console.log('error in unclaim devices');
    }
    //this.breadCrumbService.removeLastBreadCrumb();
    this.prodcode = sessionStorage.getItem('prodcode');
    const callingPageUrl = this.breadCrumbService.getLastUrlFromBreadCrumb().routerLink;
    this.callingBackUrl = callingPageUrl.currentUrl;
    //sessionStorage.setItem('cancelCallingBackUrl', JSON.stringify({ callingPageUrl }));
    this.cancelParticipationService.createPageLoadProperties('UNCLAIMDEVICES', 'unclaimdevices');

    // Content Rendering
  }

  getContent() {
    this.SelectedFANList = this.FANList.filter(item => item.selected === true);
    this.pageContent = this.route.snapshot.data.pageData.cancelParticipationunclaimdevices;
    this.pageContent.selectedFans = `You've selected to remove devices from ${this.SelectedFANList.length} of the ${this.FANList.length} foundation <account/accounts>`
    this.pageContent.selectedFans = this.pageContent.selectedFans.replace('<account/accounts>',
    this.SelectedFANList.length === 0 ? 'accounts.' : this.SelectedFANList.length > 1 ? 'accounts.' : 'account.');
    console.log(this.pageContent.selectedFans);
  }

  backToCallingPage() {
    sessionStorage.removeItem('fanLength');
    sessionStorage.removeItem('CancelParticipationData');
    sessionStorage.removeItem('UnclaimDevicesData');
    const previousUrl = sessionStorage.getItem('previousRoute');
    if(previousUrl === '/cancelParticipation/unclaimdevices') {
      this.router.navigate(['cancelParticipation/unclaimdevices']);
      }
      else {
      this.router.navigate(['cancelParticipation/selectfan']);
      }
  }


  initGrid() {
    const options = new GridOptionsModel();
    options.enableSorting = false;
    options.multiSelect = true;
    options.enableBackLink = true;
    options.backLinkText = 'View all accounts';

    const pagination = {
      recordsPerPage: 20,
      currentPage: 1,
      isServerSide: false,
      totalRecords: this.FANList.length
    };

    options.Paginations = pagination;
    options.gridData = this.FANList;
    options.callbacks = {statusCellTemplate: this.statusCellTemplate};

    options.columnDefinitions = CANCELFANDATA.fanList[this.columnSelection].columnDefinitions;
    options.disableRow = CANCELFANDATA.fanList[this.columnSelection].rowDisable;
    options.disableRowCondition = CANCELFANDATA.fanList[this.columnSelection].rowDisableCondition;
    this.gridOptions = options;
  }


 statusCellTemplate(element, row, field, currentElem, type) {
    if (type === 'template') {
      if (row.profileName !== undefined || row.profileName !== null) {
        row.profileName = '';
      }
      this.mdmDetails = JSON.parse(sessionStorage.getItem('mdmDetails'));
      this.prodDets = JSON.parse(sessionStorage.getItem('manage-product'));
      this.fanInfoList = JSON.parse(sessionStorage.getItem('fanInfoList'));
      if(this.prodDets.emmProductCode === 'DMPGZTP'){
        this.accountemmid = this.mdmDetails.googleEmmAccountId;
        this.accountId ='ZTP ID: ' + this.accountemmid;
      }
      else if(this.prodDets.emmProductCode === 'DMPSKME'){
        this.accountemmid = this.mdmDetails.samsungEmmAccountId;
        this.accountId ='KME ID: ' + this.accountemmid;
      }
      else if(this.prodDets.emmProductCode === 'DMPAABM'){
        this.fanInfoList.forEach(element => {
          if(row.fanId === element.fan && row.productCode === element.emmProductCode){
            this.accountemmid = element.emmAccountId;
            this.accountId ='Apple Org ID: ' + this.accountemmid;
          }
          });
      }

      return `<div>${CANCELFANDATA.statusLabel[row.accountStatus] === 'ACTIVE' ? this.accountId : this.accountId }</div>`;
      //return `<div>${CANCELFANDATA.statusLabel[row.accountStatus] === 'ACTIVE' ? 'Active' : 'Active'}</div>`;
      //return `<div>${CANCELFANDATA.statusLabel[row.accountStatus] === undefined ? 'Ready for setup' : CANCELFANDATA.statusLabel[row.accountStatus]}</div>`;
    }
  }

  /* Fan selection watched here from Grid*/
  onRowClick(action) {
    this.SelectedFANList = this.FANList.filter(item => item.selected === true);
    // this.pageContent.selectedFans = this.pageContent.selectedFanTmp.replace('<selectedFanCount>', this.SelectedFANList.length);
    // this.pageContent.selectedFans = this.pageContent.selectedFanTmp.replace('<removeFanCount>', this.FANList.length);
    this.pageContent.selectedFans = `You've selected to remove devices from ${this.SelectedFANList.length} of the ${this.FANList.length} foundation <account/accounts>`
    this.pageContent.selectedFans = this.pageContent.selectedFans.replace('<account/accounts>',
        this.SelectedFANList.length === 0 ? 'accounts.' : this.SelectedFANList.length > 1 ? 'accounts.' : 'account.');
  }

  unclaimReviewPage() {  
    this.adobeAnalyticsService.createAdobeEventProperties('CANCELPARTICIPATION', 'SUCCESS', 'formSubmit',
    'BC_Device_Cancel_Select_FAN_Submit', 'success', 'Success_Admit', 'Remove accounts', 'Body',
    '/businessconsole/cancelParticipation/review');
    if (this.SelectedFANList.length == 0) {
      sessionStorage.setItem('unclaimFlag', 'false');
    }
    this.cancelParticipationService.saveCancelledFAN(this.FANList, this.SelectedFANList, this.columnSelection = 'singlecol');
    //sessionStorage.setItem('unclaimFlag', 'true');
    // Adobe Analytics Success Type Starts
    this.adobeAnalyticsService.createAdobeEventProperties('CANCELPARTICIPATION', 'SUCCESS',
    'formResponse', 'BC_Device_Cancel_Select_FAN_Submit', 'success', 'Success_Admit', 'Remove accounts',
    'Body', '/businessconsole/cancelParticipation/review');
    // Ends
    this.router.navigate(['cancelParticipation/review']);
  }

}